<template>
  <div>
    <Head title="Sorting" />
    <h1 class="mb-8 text-3xl font-bold">Sorting</h1>
    <div class="flex items-center justify-between mb-1 mt-2">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3" />
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset" />
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Item UID</th>
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Description</th>
          <th class="pb-3 pt-3 px-3">Quantity</th>
          <th class="pb-3 pt-3 px-3" colspan="2">UoM</th>
        </tr>
        <tr v-for="item in issuances.data" :key="item.issuance_id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`"
            >
              {{ item.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3"
              tabindex="-1"
              :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`"
            >
              {{ item.item_uid }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3"
              tabindex="-1"
              :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`"
            >
              {{ item.part_no }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3"
              tabindex="-1"
              :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`"
            >
              {{ item.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1" :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`">
              {{ item.quantity }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1" :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`">
              {{ item.measure }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-3" :href="`manufacturing-issuances/${item.issuance_id}/sorted-items`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="issuances.data.length === 0">
          <td class="px-2 py-2 border-t" colspan="7">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="issuances.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
//import SearchFilterRight from '@/Shared/SearchFilterRight'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
// import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    DateRange,
    SearchWithDateRange,
    //SearchFilterRight,
    SearchFilter,
    TextInput,
    //SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  props: {
    issuances: Object,
    filters: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/sorting-issuances/', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
